import * as React from 'react';
import { AvensiaNinetailedProvider, useAvensiaNinetailedFeatureTest } from '@avensia/excite-ninetailed';
import NinetailedGoogleTagmanagerPlugin from '@ninetailed/experience.js-plugin-google-tagmanager';
import NinetailedPrivacyPlugin from '@ninetailed/experience.js-plugin-privacy';
import { useStaticData } from '@avensia/excite';
import { FEATURES } from '@ninetailed/experience.js-shared';

function getStarterSiteNtPlugins(): any[] {
  return [
    new NinetailedPrivacyPlugin({
      allowedEvents: ['page', 'track', 'identify', 'screen', 'group', 'alias', 'component'],
      enabledFeatures: [FEATURES.LOCATION],
      allowedTraits: ['isLoggedIn'],
    }),
    new NinetailedGoogleTagmanagerPlugin({
      template: {
        ninetailed_audience_name: '{{ audience.name }}',
      },
    }),
  ];
}

export function NordicnestNinetailedProvider(props: React.PropsWithChildren) {
  return <AvensiaNinetailedProvider plugins={getStarterSiteNtPlugins()}>{props.children}</AvensiaNinetailedProvider>;
}

export function useNinetailedFeatureTest<T extends HTMLElement>(feature: string, activeTracking: boolean = true) {
  const featureExperiences = useStaticData<Excite.Ninetailed.NinetailedFeatureTestApiModel>();
  return useAvensiaNinetailedFeatureTest<T>(feature, featureExperiences, activeTracking);
}
